<div class="flex h-screen overflow-hidden bg-gray-100 w-full relative">

    <!-- Desktop Sidebar -->
    <vg-sidebar class="hidden md:flex flex-col bg-primary-green transition-all duration-300"
                 [class.w-64]="!isDesktopSidebarCollapsed"
                 [class.w-20]="isDesktopSidebarCollapsed"
                 [collapsed]="isDesktopSidebarCollapsed">
    </vg-sidebar>

    <!-- Mobile Sidebar (Drawer) -->
    <div *ngIf="isSidebarOpen" class="fixed inset-0 z-40 md:hidden">
        <!-- Overlay -->
        <div class="absolute inset-0 bg-gray-600 bg-opacity-75 transition-opacity" (click)="toggleSidebar()"></div>

        <!-- Sidebar Panel -->
        <div class="absolute inset-y-0 left-0 flex flex-col w-64 bg-primary-green transition-transform duration-300 transform shadow-xl">
             <vg-sidebar class="flex flex-col h-full"></vg-sidebar>
        </div>
    </div>

    <!-- Main Content Wrapper -->
    <div class="flex flex-col flex-1 min-w-0 h-full overflow-hidden relative">
        <vg-header (toggleSidebar)="toggleSidebar()"></vg-header>

        <main class="flex-1 overflow-y-auto p-4 md:p-6 scroll-smooth bg-gray-50/50">
            <router-outlet></router-outlet>
        </main>

        <vg-footer></vg-footer>
    </div>
</div>
